export default "__VITE_ASSET__acfdc615__"